import { useEffect, useState } from "react";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { useNavigate } from "react-router-dom";
import "./MyAdquisitionContractDetail.css";
import { InfoSecop } from "../../../../../../../modules/contract/etapa-contrato/contrac/InfoSecop";
import { MyAdquisitionContractModify } from "./Components/MyAdquisitionContractModify/MyAdquisitionContractModify";
import { MyResumenContractPayment } from "./Components/MyResumenContractPayment/MyResumenContractPayment";
import { MyExpedientContractFiles } from "./Components/MyExpedientContractFiles/MyExpedientContractFiles";
import { usePortal } from "../../../../../hook/usePortalState";
import useModal, { MODAL_XL } from "../../../../../../../modules/theme/Component/hooks/useModal";
import { Modal } from "../../../../../../../modules/theme/Component/Modal";
import { VisorDocumentFactory } from "../../../../../../../modules/documents/VisorDocumentFactory";

export const MyAdquisitionContractDetail = () => {

    const [contract, setContract] = useState<any>(null);
    const navigate = useNavigate();
    const { isMovil } = usePortal();

    const [document, setDocument] = useState<any>({});
    const modalDocumento = useModal("Documento", MODAL_XL);

    useEffect(() => {
        if (document.Mnemonic != null && document.Consecutive != null) {
            modalDocumento.open();
        }
    }, [document])


    useEffect(() => {
        const data = _single.getSessionItem("contractSelected");
        if (data) {
            setContract(JSON.parse(data));
        }
    }, []);

    if (!contract) return <div>No hay información</div>;

    return (
        <>
            <div className="contract-detail-container">
                <div className="contract-header">
                    <button
                        className="btn btn-light btn-sm contract-back-btn"
                        onClick={() => navigate(-1)}
                    >
                        <i className="ri-arrow-left-line me-1"></i>
                        Volver
                    </button>

                    <h3>{contract.InternalCode}</h3>

                    <small className="contract-subtitle">
                        {contract.Description}
                    </small>
                </div>

                <div className={`contract-main-grid ${isMovil ? "mobile" : ""}`}>
                    <div className="contract-column">

                        <div className="contract-card contract-info">
                            <div className="contract-title">Información</div>

                            <p><strong>Modalidad:</strong> {contract.NameModality}</p>
                            <p><strong>Tipo:</strong> {contract.ContractTypeName}</p>

                            <hr />

                            <p><strong>Proveedor:</strong> {contract.Name1}</p>
                            <p><strong>NIT:</strong> {contract.Nit}</p>

                            <hr />

                            <p><strong>Valor:</strong> ${contract.ContractAmount?.toLocaleString("es-CO")}</p>
                            <p><strong>Inicio:</strong> {contract.SeleccionDate}</p>
                            <p><strong>Fin:</strong> {contract.EndContractDate}</p>
                        </div>

                        <div className="contract-card">
                            <div className="contract-title">Expediente</div>
                            <MyExpedientContractFiles
                                IDAdquisitionItem={contract.IDAdquisitionItem}
                            />
                        </div>

                    </div>

                    <div className="contract-column">
                        <div className="contract-card">
                            <div className="contract-title">Ejecución del Contrato</div>
                            <MyResumenContractPayment
                                documentSetter={(e) => { setDocument(e) }}
                                nameProp="IDAdquisitionContract"
                                props={contract}
                            />
                        </div>

                        <div className="contract-card">
                            <div className="contract-title">Modificaciones Contractuales</div>
                            <MyAdquisitionContractModify contract={contract} />
                        </div>

                        <div className="contract-card">
                            <InfoSecop contract={contract} />
                        </div>
                    </div>

                </div>
            </div>

            <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                <VisorDocumentFactory Consecutive={document.Consecutive} Mnemonic={document.Mnemonic} />
            </Modal>
        </>
    );
};